<template>
  <div class="makercrate-filter-section">
    <div class="d-flex ga-3 justify-start">
      <LocaleSelector
        v-model="selectedLocale"
        @update:modelValue="handleLocaleChange"
        :is-singapore-disabled="true"
      />
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from "vue";

import LocaleSelector from "@/components/common/LocaleSelector.vue";

const props = defineProps({
  selectedLocale: {
    type: String,
    default: "US",
  },
});

const selectedLocale = computed(() => props.selectedLocale);

const emit = defineEmits(["update:selectedLocale"]);

const handleLocaleChange = (payload) => {
  if (!payload) return;
  emit("update:selectedLocale", payload);
};
</script>

<style scoped>
@media (max-width: 480px) {
  .makercrate-filter-section {
    display: none;
  }
}
</style>
